'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { API_Data_Edit_Self_Response } from "@/interfaces/api/self/api_response_types"
import { EditSelfData } from "@/interfaces/api/self/api_request_types"
import { editSelf } from "../requests/user"

export const useEditSelf = () => useMutation<API_Data_Edit_Self_Response, API_Error, EditSelfData>({
    retry: false,
    mutationFn: editSelf
})